// Classic scrollbars take room inside a scroller; a lockstep follower pane must reserve the same gutter to
// get the same scroll range. Layout pixels (pre 75% zoom), see ./pointerCoords.
export type ScrollbarGutter = {
  bottom: number
  right: number
}

export const NO_SCROLLBAR_GUTTER: ScrollbarGutter = { bottom: 0, right: 0 }

/** Reads layout: call from an effect or ResizeObserver, not during render. */
export function measureScrollbarGutter(el: HTMLElement | null | undefined): ScrollbarGutter {
  if (!el) return NO_SCROLLBAR_GUTTER

  // offset* includes borders, client* does not, so borders come off via computed style. No layout gives 0.
  const style = el.ownerDocument?.defaultView?.getComputedStyle(el)
  const px = (value: string | undefined) => parseFloat(value ?? "") || 0

  return {
    bottom: Math.max(
      0,
      el.offsetHeight - el.clientHeight - px(style?.borderTopWidth) - px(style?.borderBottomWidth)
    ),
    right: Math.max(
      0,
      el.offsetWidth - el.clientWidth - px(style?.borderLeftWidth) - px(style?.borderRightWidth)
    ),
  }
}
